import { Component } from '@angular/core';

import { pedidoEmAnalise } from '../../pedido-status';

@Component({
    selector: 'sgt-pedido-status-badge-em-analise',
    templateUrl: './pedido-status-badge-em-analise.component.html',
    styleUrls: ['./pedido-status-badge-em-analise.component.less']
})
export class PedidoStatusBadgeEmAnaliseComponent {
    status = pedidoEmAnalise;
}
